import icon from "../../assets/resolution.svg";
import type { Property } from "../../types";

export const cameraResolution: Property = {
  id: "cameraResolution",
  title: "cameraResolution.title",
  icon,
};
